jQuery(document).ready(function ($) {
  $(function () {
    $(".show-more-library-images").click(function () {
      $( this ).next().toggle('slow');
      $( this ).hide();
    });
  });
});
